import { render, staticRenderFns } from "./registerdebitevents.vue?vue&type=template&id=2b8392a1&"
import script from "./registerdebitevents.vue?vue&type=script&lang=js&"
export * from "./registerdebitevents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports